export default __webpack_public_path__ + "static/media/blog1.d0d97e6b.png";